@import '../../styles/palette.scss';
@import '../../styles/mixins.scss';
@import '../../styles/fonts.scss';

.alpBaseModal {
  background: _palette(modal-bg-primary);
  border-radius: 5px;
  -webkit-box-shadow: -1px 9px 38px -15px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 9px 38px -15px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 9px 38px -15px rgba(0, 0, 0, 0.75);
  margin: auto;
  outline: none;

  & > * {
    border-left: solid 20px _palette(modal-left-border-primary);
    padding-left: 24px;
    padding-right: 40px;
  }

  .alpModalHeader {
    background: _palette(modal-bg-secondary);
    border-bottom: solid 1px _palette(border-strong);
    border-left: solid 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-bottom: 10px;
    padding-top: 15px;

    &.practicePeriodColorScheme {
      @include practicePeriodColorScheme();
    }

    h2,
    h3 {
      @include ellipsis();
    }

    h2 {
      @include merriweather(20);
      height: 28px;
      line-height: 28px;
    }

    h3 {
      @include barlow(14);
      height: 16px;
      line-height: 16px;
    }
  }

  .alpModalContents {
    padding-top: 6px;
  }

  .alpModalFooter {
    background: _palette(modal-bg-secondary);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    height: 65px;
    padding-bottom: 15px;
    padding-top: 15px;
    text-align: right;

    button {
      @include barlow(16, 600);
      letter-spacing: 0.5px;
      margin-left: 24px;
      padding: 6px 30px;
      text-transform: none;
    }
  }
}
